import FieldProto from "../../../proto/field-proto"
import {FieldType} from "../../../field-type"
import {MyTimeListGroup} from "../../../../../app/home/my-time/daily/@type"
import GroupBy from "../../../../gd/manager/group-by/group-by-model"
import ItemModelV2 from "../../../../model2/item2/item-model"
import FieldTimeReportActivityType_ViewGroup from "./render/group/group"
import {TimeReport_ActivityType} from "../../../../model2/time-report/@const"
import FieldString from "../../../generic/string/string";
import FieldConfig from "../../../proto/field-config";

const GROUP_ORDER = [
    TimeReport_ActivityType.MEETINGS,
    TimeReport_ActivityType.LOGGED_TIME,
    TimeReport_ActivityType.WORKED_ON,
    TimeReport_ActivityType.PLANNED_TASKS,
    TimeReport_ActivityType.PINNED_TASKS,
    TimeReport_ActivityType.RECENT_TASKS,
]

export default class FieldTimeReportActivityType extends FieldProto {

    public groupById: Record<ID, MyTimeListGroup> = {
        [TimeReport_ActivityType.MEETINGS]: {
            id      : TimeReport_ActivityType.MEETINGS,
            title   : 'Meetings',
            icon    : 'i5-meeting-light',
            hint    : '',
            data    : [],
            display : true,
        },
        [TimeReport_ActivityType.LOGGED_TIME]: {
            id      : TimeReport_ActivityType.LOGGED_TIME,
            title   : 'Logged time',
            icon    : 'i5-time-reported',
            hint    : 'Tasks with time logged',
            data    : [],
            display : true,
        },
        [TimeReport_ActivityType.WORKED_ON]: {
            id      : TimeReport_ActivityType.WORKED_ON,
            title   : 'Worked on',
            icon    : 'i5-todo',
            hint    : 'Active tasks with no time logged',
            data    : [],
            display : true,
        },
        [TimeReport_ActivityType.PLANNED_TASKS]: {
            id      : TimeReport_ActivityType.PLANNED_TASKS,
            title   : 'Planned',
            icon    : 'i5-calendar-light',
            hint    : 'Tasks scheduled for these dates',
            data    : [],
            display : true,
        },
        [TimeReport_ActivityType.PINNED_TASKS]: {
            id      : TimeReport_ActivityType.PINNED_TASKS,
            title   : 'Pinned',
            icon    : 'i5-pin-2',
            hint    : 'Pinned tasks for quick access',
            data    : [],
            display : true,
        },
        [TimeReport_ActivityType.RECENT_TASKS]: {
            id      : TimeReport_ActivityType.RECENT_TASKS,
            title   : 'Recent tasks',
            icon    : 'i5-recent',
            hint    : 'Recently viewed tasks',
            data    : [],
            display : true,
        },
    }

    constructor(config:FieldConfig) {
        super(config)

        this.icon               = 'i5-type'

        this.isGroupByAvailable = true

        this.renderComponents.viewGroup = FieldTimeReportActivityType_ViewGroup
    }

    groupItemValue(itemModel: ItemModelV2, groupBy: GroupBy): any {
        return itemModel.timeReport?.activityType ?? null
    }

    groupSortValue(value: any): number {
        const index = GROUP_ORDER.indexOf(value)
        return index === -1 ? Number.MAX_SAFE_INTEGER : index
    }

    groupLabel(value: any, groupBy?: GroupBy): string {
        return this.groupById[value]?.title ?? value
    }

    groupValue(value: any, groupBy?: GroupBy): any {
        return value
    }
}
